// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3515":"8f30f5d2","6773":"4e699bd5","9870":"8f30f5d2"}[chunkId] + ".chunk.css";
};